import {
  type OfferPlacement,
  type ProFeatureId,
  proOfferHref,
  proOfferLine,
  seePro,
} from "../user/pro-offer.js";

/**
 * The offer of Pro 专业 as a page script draws it, after a line of text.
 *
 * The Exercise finish and the segmenter write their lines as `textContent`,
 * so the offer is the table's `Free: X. Pro: Y.` in English, then a link built
 * as an element rather than markup. `src/user/pro-offer-markup.ts` is the same
 * offer for the pages the handler draws.
 * @param line - The element the line is in, which the offer is appended to.
 * @param placement - Where it is drawn, which the link carries.
 * @param feature - The row it is about.
 */
export function appendProOffer(
  line: HTMLElement,
  placement: OfferPlacement,
  feature: ProFeatureId,
): void {
  const document = line.ownerDocument;
  const link = document.createElement("a");

  link.className = "cb-offer-link";
  link.href = proOfferHref(placement, feature);
  link.textContent = seePro.english;
  line.append(` ${proOfferLine(feature).english} `, link);
}
